import { render, staticRenderFns } from "./PaymentFees.vue?vue&type=template&id=4d83da36&"
import script from "./PaymentFees.vue?vue&type=script&lang=js&"
export * from "./PaymentFees.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFees.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports